var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "popup popup-full",
      attrs: { id: "search", tabindex: "-1", "aria-hidden": "true" }
    },
    [
      _vm._m(0),
      _c("div", { staticClass: "search_page" }, [
        _c("div", { staticClass: "search_box" }, [
          _c("span", [_vm._v("#")]),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.searchTerm,
                expression: "searchTerm"
              }
            ],
            attrs: { type: "text", "aria-label": "검색어 입력" },
            domProps: { value: _vm.searchTerm },
            on: {
              input: [
                function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.searchTerm = $event.target.value
                },
                _vm.autoSearch
              ],
              keydown: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.searchKey.apply(null, arguments)
              }
            }
          }),
          _c(
            "a",
            {
              attrs: { href: "javascript:void(0)" },
              on: {
                click: function($event) {
                  return _vm.searchKey(_vm.searchKey)
                }
              }
            },
            [
              _c("img", {
                attrs: {
                  src: require("@/assets/images/i_search_color.png"),
                  alt: "검색"
                }
              })
            ]
          )
        ]),
        _c("dl", { staticClass: "search_page_box" }, [
          _c("dt", [
            _c("span", { staticClass: "st" }, [_vm._v("최근 검색어")]),
            _c(
              "a",
              {
                staticClass: "del",
                attrs: { href: "javascript:void(0)" },
                on: { click: _vm.allDelCookie }
              },
              [_vm._v("전체삭제")]
            )
          ]),
          _c("dd", [
            _c(
              "ul",
              { staticClass: "search_page_reslt" },
              _vm._l(_vm.recentSearchKey, function(key2) {
                return _c(
                  "li",
                  {
                    key: key2,
                    on: {
                      click: function($event) {
                        ;[(_vm.searchTerm = key2), _vm.searchKey()]
                      }
                    }
                  },
                  [
                    _c("a", { attrs: { href: "javascript:void(0)" } }, [
                      _vm._v(" #" + _vm._s(key2) + " "),
                      _c(
                        "a",
                        {
                          staticClass: "del",
                          staticStyle: { padding: "0" },
                          attrs: { href: "javascript:void(0)" },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.delCookie("dq_cookie", key2)
                            }
                          }
                        },
                        [
                          _c("span", { staticClass: "sr-only" }, [
                            _vm._v(_vm._s(key2) + " 검색어 삭제")
                          ]),
                          _c("i", { staticClass: "xi-close" })
                        ]
                      )
                    ])
                  ]
                )
              }),
              0
            )
          ])
        ])
      ]),
      _c("div", { staticClass: "popup search_01" }, [
        _c("div", { staticClass: "popup_container" }, [
          _c("header", { staticClass: "popup_header" }, [_vm._v("안 내")]),
          _c("div", { staticClass: "popup_content" }, [
            _c("p", { domProps: { innerHTML: _vm._s(_vm.alertMsg) } })
          ]),
          _vm._m(1)
        ]),
        _c("div", { staticClass: "dimBg" })
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("header", { staticClass: "replboxHead" }, [
      _c("h1", [_vm._v("통합검색")]),
      _c("div", { staticClass: "menu_side" }, [
        _c(
          "a",
          {
            staticClass: "btn_detail_close",
            attrs: {
              onclick: "backBtn('popup-full')",
              href: "javascript:void(0)"
            }
          },
          [
            _c("span", { staticClass: "sr-only" }, [_vm._v("검색창 닫기")]),
            _c("i", { staticClass: "xi-close" })
          ]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "popup_button" }, [
      _c(
        "button",
        { staticClass: "btn_large", attrs: { onclick: "modal('search_01')" } },
        [_vm._v("확 인")]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }